import { create } from "zustand";
import axios from "../helper/axios";
const useExportTemplateStore = create((set) => ({
  currentExportTemplateArray: [
    "Date",
    "Payroll",
    "Vendor",
    "Role",
    "Candidate Name",
    "Contact No.",
    "Email",
    "Total Work Exp",
    "Current Location",
    "Preferred Location",
    "Highest Qualification",
    "Current Company",
    "Current Designation",
    "Current Salary",
    "Expected Salary",
    "Notice Period",
    "Status",
  ],

  allExportTemplates: [],

  setCurrentExportTemplateArray: (value) =>
    set({ currentExportTemplateArray: value }),

  getAllExportTemplate: async () => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.get(
        `/getAllExportTrackerTemlplates/${userDetails.qhoid}/${userDetails.qhuid}`
      );
      console.log(response.data.data);
      set({ allExportTemplates: response.data.data });
    } catch (err) {
      console.log(err);
    }
  },

  createExportTemplate: async (body) => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.post(
        `/updateExportTrackerTemplates/${userDetails.qhoid}/${userDetails.qhuid}`,
        body
      );
      console.log(response.data.data);
      const get = useExportTemplateStore.getState();
      await get.getAllExportTemplate();
    } catch (err) {
      console.log(err);
    }
  },

  updateExportTemplate: async (body) => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.post(
        `/updateExportTrackerTemplates/${userDetails.qhoid}/${userDetails.qhuid}`,
        body
      );
      console.log(response.data.data);
      const get = useExportTemplateStore.getState();
      await get.getAllExportTemplate();
    } catch (err) {
      console.log(err);
    }
  },

  deleteExportTemplate: async (id) => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.post(
        `/updateExportTrackerTemplates/${userDetails.qhoid}/${userDetails.qhuid}`,
        {
          UpdateType: "TEMPLATE_DELETE",
          TemplateList: [
            {
              TemplateId: id,
            },
          ],
        }
      );
      console.log(response.data.data);
      const get = useExportTemplateStore.getState();
      await get.getAllExportTemplate();
    } catch (err) {
      console.log(err);
    }
  },
}));

export default useExportTemplateStore;
